var withSelector = { exports: {} };
export {
  withSelector as __module
};
//# sourceMappingURL=with-selector2.mjs.map
